import { Injectable } from "@angular/core";
import { CmpModalPriceDescComponent } from "./cmp-modal-price-desc.component";
import { NzModalService } from "ng-zorro-antd/modal";
import { Translate } from "@root/util/decorator";
@Injectable({ providedIn: "root" })
export class CmpModalPriceDescService {
  @Translate("calendar.price_info.tip") modalTitle;

  constructor(private modalService: NzModalService) {}

  displayPriceModal() {
    this.modalService.create({
      nzTitle: this.modalTitle,
      nzContent: CmpModalPriceDescComponent,
      nzFooter: null,
      nzWidth: 440,
    });
  }
}
